import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setStep, STEPS } from 'components/QuestionnaireRequestAutomated/processor/slices/interstitialSlice'
import { selectAnySignedSigntures } from 'components/QuestionnaireRequestAutomated/processor/slices/formInstanceSlice'
import { clsx } from 'clsx'

export default function SignEditSwitchButtons(props) {
  const isAnySignedSignatures = useSelector(selectAnySignedSigntures)
  const step = useSelector((state) => state.interstitial.step)
  const dispatch = useDispatch()

  const onGoToEdit = useCallback(() => {
    if (isAnySignedSignatures) return

    dispatch(setStep(STEPS.edit))
  }, [dispatch, isAnySignedSignatures])

  return (
    <div className="questionnaire-request-interstitial-sign-header-switch-buttons">
      <div
        aria-description={step === STEPS.sign ? 'sign' : 'edit'}
        className="questionnaire-request-interstitial-sign-header-switch-buttons-active"
      ></div>
      <div className="questionnaire-request-interstitial-sign-header-switch-buttons-content">
        <span
          style={{ padding: '2px 8px 0px 12px' }}
          onClick={onGoToEdit}
          className={clsx('dome-p2 dome-color-med-grey', {
            'dome-cursor-not-allowed': isAnySignedSignatures,
            'dome-cursor-pointer': !isAnySignedSignatures,
          })}
        >
          edit
        </span>
        <span
          style={{ padding: '2px 12px 0px 8px' }}
          onClick={() => dispatch(setStep(STEPS.sign))}
          className="dome-p2 dome-color-med-grey dome-cursor-pointer"
        >
          sign
        </span>
      </div>
    </div>
  )
}
